import { useEffect, useState } from 'react'
import api from '../../lib/api'
import Card from './Card'
import './Programs.sass'

export default function Programs() {
    const [data, setData] = useState()
    const [height, setHeight] = useState(0)

    const load = () => {
        // api.service('events').find().then(r=>console.log(r))
        api.service('events').find()
            .then(setData)
    }

    useEffect(load, [])

    return (
        <section className="section-programs">
            <div className="container">
                <div className="program">
                    <h1 className="program-title h1">Обучение малярным работам в Санкт-Петербург от компании Danogips</h1>
                    <h3 className="program-title">
                        ПРОГРАММЫ
                    </h3>
                    <div className="program-row">
                        {data &&
                            data.data.map((item) =>
                                <Card key={item._id} event={item} height={height} setHeight={setHeight}/>
                            )}
                    </div>
                </div>
            </div>
        </section>
    )
}